// noinspection JSUnusedGlobalSymbols

export default class
{
	static email(file)
	{
		$.get(`/error/?email=${file}`, (data) =>
		{
			$('#email').html(data.replace(/\n/g, "<br>\n"))

			$(`[data-remodal-id="email"]`).remodal({
				hashTracking: false,
			}).open()
		})
	}

	static retry(type, id)
	{
		$.post(`/error/?__action=retry&type=${type}&id=${id}`)
	}
}
